<template>
  <div class="wrapper" @click="navigateToLink">
    <h4 class="label">{{ row.label }}</h4>
    <div class="pending_flag" v-if="row.flag.open">
      <span>{{ row.flag.open }}</span>
      <PendingFlag />
    </div>
    <div class="resolved_flag" v-if="row.flag.closed">
      <span>{{ row.flag.closed }}</span>
      <ResolvedFlag />
    </div>
  </div>
</template>

<script>
import PendingFlag from "../../icons/PendingFlag.vue";
import ResolvedFlag from "../../icons/ResolvedFalg.vue";

export default {
  name: "FlagFormatter",
  props: ["row"],
  components: {
    PendingFlag,
    ResolvedFlag,
  },
  methods: {
    navigateToLink() {
      if (this.row.redirectPath) {
        this.$router.push({ path: this.row.redirectPath });
      }
    },
  },
};
</script>

<style scoped>
.label {
  text-decoration: underline;
  font-size: 14px;
  line-height: 12px;
  margin-right: 5px;
}

.wrapper {
  display: flex;
  align-items: center;
}

.pending_flag,
.resolved_flag {
  display: flex;
  align-items: center;
  margin: 0 5px;
  padding: 0px 5px;
  border-radius: 10px;
}

.pending_flag {
  background: #ffebeb;
}

.resolved_flag {
  background: #e7ffea;
}
</style>
